import { getElementPosition } from "../services/service-utils";
import { cprValidator } from "../validators/cpr-validator";

export const validateFields = (container, fields) => {
  // optional "fields"

  const requiredFields = fields ? fields : container.querySelectorAll(".required");
  let result = true;

  requiredFields.forEach(requiredField => {
    const fieldResult = validateField(requiredField, container);

    if (!fieldResult) {
      result = false;
    }
  });

  if (result === false && container) {
    const errorContainer = container.querySelector(".required.show.error") ? container.querySelector(".required.show.error") : container.querySelector(".required.error");

    const yPos = getElementPosition(errorContainer).top - 80;

    window.scrollTo({
      top: yPos,
      behavior: "smooth",
    });
  }

  return result;

};

export const validateField = (requiredField, container) => {
  let input = requiredField.querySelector("input:not(.flatpickr),select,textarea");

  // if input is only visible as part of a group checkbox/radiobutton, then only validate it if it is visible
  input = requiredField.getAttribute("data-group-receiver") && !requiredField.classList.contains("show") ? null : input;

  if (input) {
    input.value = input.value.trim();

    const type = input.getAttribute("type");
    const customValdation = input.getAttribute("custom-validation");

    if (customValdation) {
      const pattern = new RegExp(customValdation);

      let isValid = pattern.test(input.value);

      if (input.id === "form_Cpr") {
        isValid = cprValidator(input.value);
      }

      if (!isValid) {
        requiredField.classList.add("error");
        return false;
      } else {
        requiredField.classList.remove("error");
      }
    } else if (type === "text" || type === "number" || type === "hidden" || type === "date" || input.tagName.toLowerCase() === "select" || input.tagName.toLowerCase() === "textarea") {
      if (input.value.length === 0) {
        requiredField.classList.add("error");
        return false;
      } else if (input.classList.contains("flatpickr-input")) {
        // If it is a hidden date field see if there are any date comparison validation

        const dateComparisonName = input.getAttribute("data-validation-date-less-than");
        const dateComparisonMoreName = input.getAttribute("data-validation-date-more-than");
        if (dateComparisonName) {
          const dateComparerInput = container.querySelector(`[name='${dateComparisonName}']`);

          if (dateComparerInput) {
            const startDate = new Date(input.value);
            const endDate = new Date(dateComparerInput.value);

            if (startDate >= endDate) {
              requiredField.classList.add("error");
              return false;
            }
          }
          requiredField.classList.remove("error");
        } else if (dateComparisonMoreName) {
          // Date comparison more
          const dateComparerInput = container.querySelector(`[name='${dateComparisonMoreName}']`);

          if (dateComparerInput) {
            const endDate = new Date(input.value);
            const startDate = new Date(dateComparerInput.value);

            if (startDate >= endDate) {
              requiredField.classList.add("error");
              return false;
            }
          }
          requiredField.classList.remove("error");
        } else {
          requiredField.classList.remove("error");
        }
      } else {
        requiredField.classList.remove("error");
      }
    }

    if (type === "email") {
      const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);

      if (!isEmailValid) {
        requiredField.classList.add("error");
        return false;
      } else {
        requiredField.classList.remove("error");
      }
    }

    if (type === "checkbox" || type === "radio") {
      const identifier = input.name ? input.name : input.id ? input.id : null;

      if (identifier) {
        const groupCheckboxes = container.querySelectorAll(".required input[name='" + identifier + "']:checked, .required input[id='" + identifier + "']:checked");

        if (groupCheckboxes.length === 0) {
          requiredField.classList.add("error");
          return false;
        } else {
          requiredField.classList.remove("error");
        }
      }
    }

    // Pond input files
    if (type === "file" && input.classList.contains("filepond--browser")) {
      // eslint-disable-next-line no-undef
      const pondInstane = pond;

      if (pondInstane) {
        if (pondInstane.getFiles().length == 0) {
          requiredField.classList.add("error");
          return false;
        } else {
          requiredField.classList.remove("error");
        }
      }
    }

  }

  return true;
};
